// extracted by mini-css-extract-plugin
module.exports = {"option":"options__option--2sBwQ","name":"options__name--wv75m","price":"options__price--1PHBc","layout":"options__layout--1A3mJ"};